export const classBorderColor = {
  Inspección: "border-inspection",
  Mantenimiento: "border-maintenance",
  "Mantenimiento de emergencia": "border-emergency",
  "Montaje de equipos": "border-mounting",
  Preventivo: "border-preventive",
  Reclamo: "border-reclaim",
  Taller: "border-workshop",
};
